import { render, staticRenderFns } from "./AgreementPersonAdd.vue?vue&type=template&id=0ecda594&scoped=true"
import script from "./AgreementPersonAdd.vue?vue&type=script&lang=js"
export * from "./AgreementPersonAdd.vue?vue&type=script&lang=js"
import style0 from "./AgreementPersonAdd.vue?vue&type=style&index=0&id=0ecda594&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ecda594",
  null
  
)

export default component.exports